import type { FilterValueType } from '@/interfaces/components/searchBar/dynamicFilter'
import {
  alarmListingFilterDateToUtcIso,
  isAlarmListingDateField,
  isValidAlarmListingFilterDateValue,
  resolveAlarmListingFilterValueType,
} from '@/utils/alarm-listing/filter-date'

export interface IAlarmListingRansackFilter {
  field: string
  operator: string
  value: string | number | boolean
  valueType?: FilterValueType
}

function normalizeRansackFilterValue(filter: IAlarmListingRansackFilter): string {
  const resolvedType = resolveAlarmListingFilterValueType(filter.field, filter.valueType)
  const isDateFilter = resolvedType === 'date' || isAlarmListingDateField(filter.field)

  if (isDateFilter) {
    const stringValue = typeof filter.value === 'string' ? filter.value.trim() : String(filter.value)
    if (!stringValue || !isValidAlarmListingFilterDateValue(stringValue)) return ''
    return alarmListingFilterDateToUtcIso(stringValue)
  }

  return String(filter.value)
}

export function buildRansackQuery(filters: IAlarmListingRansackFilter[]): string {
  const params = new URLSearchParams()
  filters.forEach((filter) => {
    const hasValue = filter.value !== '' && filter.value !== null && filter.value !== undefined
    if (!filter.field || !filter.operator || !hasValue) return
    const normalizedValue = normalizeRansackFilterValue(filter)
    if (!normalizedValue) return
    params.append(`q[${filter.field}_${filter.operator}]`, normalizedValue)
  })
  return params.toString()
}
